import { invoke } from '@forge/bridge';

import { HOUR_IN_MILLIS } from '../../../../../src/common/constant';
import { hasValidObjectLength } from '../../utils/levelModelUtils';

import { AggregatedReport, GadgetContext } from './model';

class GadgetCacheClient {
    async set(context: GadgetContext, value: AggregatedReport, options = { ttl: HOUR_IN_MILLIS }) {
        return await invoke('cache-set', { key: this.getKey(context), value, ttl: options.ttl });
    }

    async get(context: GadgetContext) {
        const value = await invoke<AggregatedReport>('cache-get', { key: this.getKey(context) });
        return hasValidObjectLength(value) ? value : undefined;
    }

    async delete(context: GadgetContext): Promise<void> {
        return await invoke('cache-delete', { key: this.getKey(context) });
    }

    private getKey(context: GadgetContext) {
        return `gadget_${context.extension.gadget.id}_user_${context.accountId}`;
    }
}

export default new GadgetCacheClient();
